import { app } from './src/index';
import { configureStore } from './src/store/store';

require('dotenv').config();

configureStore.subscribe(app);

//app();
